/** Mapeia erros 400 de validação da API BDR para campos do formulário. */
export function mapBdrLeadValidationErrors(err: unknown): Record<string, string> | null {
  const axiosErr = err as {
    response?: {
      status?: number
      data?: {
        error?: { message?: string; details?: { field?: string; message: string }[] }
        message?: string
        errors?: { field?: string; message: string }[]
      }
    }
  }
  const status = axiosErr.response?.status
  const respData = axiosErr.response?.data
  const validationErrors = respData?.error?.details ?? respData?.errors
  if (status === 400 && validationErrors) {
    const mapped: Record<string, string> = {}
    for (const e of validationErrors) {
      if (e.field) mapped[e.field] = e.message
    }
    return mapped
  }
  return null
}
